<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid"/> {{caption}}
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="50"
        :dark="dark"
      >
       <template #wallet="{item}">
          <td class="text-left">
            <small>{{item.wallet}} </small> <span class="copybtn" href="#" v-clipboard="item.wallet"  v-clipboard:success="clipboardSuccessHandler">copy</span>
            <p>linked to user <strong>{{item.account}}</strong> </p>
           
              <step-progress :line-thickness='2' :steps="steps" :current-step="getStep(item)-1" icon-class="fa fa-check"></step-progress>
            <p class="text-center pst"><small>{{item.status}}</small></p>
            <CButton color="info" size="sm" variant="outline" @click="openOrder(item)">Details</CButton>
            <br/>
          <span v-if="(item.value_btc>0) || (item.value>0)">
            {{((item.value_btc>0)?item.value_btc+' BTC':'-')}}
             ({{((item.value>0)?item.value+' USD':'')}})<br/></span>
           <small>
            {{item.created_at}} 
            
            (Upd: {{item.updated_at}})</small>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
     <CModal
      :show.sync="modalOpen"
    >
      <div v-if='currentOrder'>

        <h5>Order # {{currentOrder.id}}</h5>
        <small>Wallet: {{currentOrder.wallet}}</small><hr/>

        <CAlert color="success">
         <div class="step active">1</div> Address Generated, linked to user <strong>{{currentOrder.account}}</strong>
        </CAlert>

        <CAlert :color="(getStep(currentOrder)>=2?'success':'secondary')" >
          <div class="step" :class="(getStep(currentOrder)>=2?'active':'')">2</div> 

          <span v-if="getStep(currentOrder)>=2">Received transaction <strong>{{currentOrder.value_btc}} BTC</strong>, rate fixed <strong>${{Math.round( currentOrder.value/currentOrder.value_btc * 100 ) / 100 }}</strong> You'll get <strong>${{currentOrder.value}}</strong> after 1 confirmation</span>

          <span v-if="getStep(currentOrder)<2">Transfer received (not confirmed in blockchain)</span>

        </CAlert>

        <CAlert :color="(getStep(currentOrder)>=3?'success':'secondary')" >
          <div class="step" :class="(getStep(currentOrder)>=3?'active':'')">3</div> Transaction confirmed
        </CAlert>

        <CAlert :color="(getStep(currentOrder)>=4?'success':'secondary')" >
         <div class="step" :class="(getStep(currentOrder)==4?'active':'')">4</div> Funds transferred to <strong>{{currentOrder.account}}</strong>
        </CAlert>

      </div>
    </CModal>  
  </CCard>
</template>

<script>
import StepProgress from 'vue-step-progress';
import './progress.css';

export default {
  name: 'Table', 
  components: {
    'step-progress': StepProgress
  }, 
  data () {
    return {
      steps: ['1','2','3','4'],
      modalOpen: false,
      currentOrder: false
    }
  },
  props: {
    items: Array,
    fields: {
      type: Array,
      default () {
        return [
          'username', 
          'registered', 
          'role', 
          'status'
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  methods: {
    clipboardSuccessHandler ({ value, event }) {
       this.$toast.open('Copied to Clipboard!');
    },
    openOrder (order){
      this.modalOpen = true;
      this.currentOrder = order;
    },
    closeOrder() {
      this.modalOpen = false;
      this.currentOrder = false;
    },
    getBadge (status) {
      return  status === 'Active'   ? 'success'
            : status === 'Inactive' ? 'secondary'
            : status === 'Pending'  ? 'warning'
            : status === 'Banned'   ? 'danger' : 'primary'
    },
    getStep (order) {
      return  ( order.status === 'new' && (order.value <= 0))  ? 1
              : order.status === 'new' ? 2
              : order.status === 'payment'  ? 3
              : order.status === 'finished'   ? 4 : 0;
    }
  }
}
</script>
<style>
.pst {
  color: blue;
  margin-bottom: 0px;
  margin-top: -5px;
}
.copybtn {
  color: blue;
  text-decoration: none;
  display: inline-block; 
  padding: 3px 5px;
  background: #ddd;
  cursor: pointer;
}
.smallt {
  font-size: 10px; 
  color: blue;
}
.step{
  display: block;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  color: #808080;
  background: #ccc;
  float: left;
  text-align: center;
  margin-right: 10px;
  font-size: 22px;
  line-height: 30px;
}
.step.active {
  color: #fff;
  background: #30b803;
}
</style>
